import React from 'react'
import PropTypes from 'prop-types'
import MoreFilters from '../MoreFilters'
import styled from 'styled-components'
import { Modal as EPModal, themeColor } from '@elparking/components'

const DesktopMoreFiltersContainer = styled.div`
    overflow: hidden;
    height: 100%;
    width: 100%;
    background: ${themeColor('white')};
    padding: 1em;
`

const MobileMoreFiltersContainer = styled.div`
    height: 100%;
`

export { DesktopMoreFiltersContainer, MoreFilters }

const isMobile = () => window.matchMedia('(max-width: 768px)').matches

// eslint-disable-next-line react/prop-types
const FilterContainer = ({ closeModal, filters, setFilters, isOpen, modal: Modal, isMobile }) => {
    if (!isOpen) {
        return null
    }

    if (isMobile()) {
        return <Modal
          isShown
          padding='0'
          position='absolute'
          label=''
          showCloseButton
          onClose={closeModal}>
            <MobileMoreFiltersContainer>
                <MoreFilters onClose={closeModal} filters={filters} setFilters={setFilters} />
            </MobileMoreFiltersContainer>
        </Modal>
    }

    return <DesktopMoreFiltersContainer>
        <MoreFilters onClose={closeModal} filters={filters} setFilters={setFilters} />
    </DesktopMoreFiltersContainer>
}

FilterContainer.propsTypes = {
    closeModal: PropTypes.func,
    setFilters: PropTypes.func,
    filters: PropTypes.object,
    isOpen: PropTypes.bool,
    modal: PropTypes.func,
    isMobile: PropTypes.func,
}

FilterContainer.defaultProps = {
    closeModal: () => {},
    setFilters: () => {},
    filters: {},
    isOpen: false,
    modal: EPModal,
    isMobile,
}

export default FilterContainer
